import { Labels } from '../../shared-components/global/labels.js';

Labels.set('ui-salesribbon', 'close', 'Uždaryti');
